export default __webpack_public_path__ + "static/media/sunk-cost-image.e995d764.svg";